// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import Theme from 'statsradio/themes';

import GeolocationReach, { calculateTopNAsPercents } from '../../../domain/GeolocationReach';
import GeoMapLayout from '../../../domain/GeoMapLayout';
import { DemographyPercent, DemographyPercentRow } from './DemographyPercentLayout';

interface Props {
  reaches: GeolocationReach[];
  layout: GeoMapLayout;

  theme: typeof Theme;
}

function GeolocalisationTopThreeRegions({ reaches, layout, theme }: Props) {
  const top3AsPercents = calculateTopNAsPercents(3, reaches);
  const withRegionNames = layout.asRegionNames(top3AsPercents);

  return (
    <DemographyPercentRow>
      {withRegionNames.map(({ regionName, reach }, index) => {
        const colors = theme.V3.colors;
        const color = index === 0 ? colors.geolocation : colors.text.emphasis;

        return (
          <DemographyPercent
            key={regionName}
            label={regionName}
            percent={reach}
            color={color}
            bold={index === 0}
          />
        );
      })}
    </DemographyPercentRow>
  );
}

export default withTheme(GeolocalisationTopThreeRegions);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/GeolocalisationTopThreeRegions.js